import {jsx as _jsx} from "react/jsx-runtime";import {Suspense} from 'react'
import useDocumentTitle from '~/hooks/useDocumentTitle'
import TeamArchive from '~/modules/teamDashboard/components/TeamArchive/TeamArchive'
import teamArchiveQuery, {} from '../__generated__/TeamArchiveQuery.graphql'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'








const ArchiveTaskRoot = ({teamIds, team, userIds, returnToTeamId}) => {
  useDocumentTitle(`Team Archive | ${team.name}`, 'Archive')

  const queryRef = useQueryLoaderNow(teamArchiveQuery, {
    userIds,
    teamIds,
    first: 40
  })

  return (
    _jsx(Suspense, { fallback: '', children: 
      queryRef && (
        _jsx(TeamArchive, { returnToTeamId: returnToTeamId, teamRef: team, queryRef: queryRef,} )
      )
    })
  )
}

export default ArchiveTaskRoot
